import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'
import { cloneDeep } from 'es-toolkit'

const globalSettings: Settings.all = {
  app: {
    enablePermission: true,
    enableDynamicTitle: true,
    locale: 'zh-cn',
    routeBaseOn: 'backend',
  },
  layout: {
    enableMobileAdaptation: true,
  },
  menu: {
    mode: 'side',
    enableSubMenuCollapseButton: true,
    enableHotkeys: true,
  },
  topbar: {
    mode: 'fixed',
  },
  tabbar: {
    enable: true,
    enableIcon: true,
    enableHotkeys: true,
  },
  toolbar: {
    enable: true,
    fullscreen: true,
    pageReload: true,
    colorScheme: true,
    i18n: true,
    notification: true,
    dataSharing: true,
  },
  copyright: {
    // enable: true,
    // dates: '2025-present',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
